import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";

interface SummaryEntry {
  key: string;
  value: unknown;
}

interface ReportExtractionSummaryCardProps {
  entries: SummaryEntry[];
  formatLabel: (key: string) => string;
  formatValue: (value: unknown) => string;
  title?: string;
}

export const ReportExtractionSummaryCard = ({
  entries,
  formatLabel,
  formatValue,
  title = "Summary",
}: ReportExtractionSummaryCardProps) => {
  if (entries.length === 0) return null;

  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {entries.map((entry) => (
            <div key={entry.key} className="flex flex-col">
              <dt className="text-xs text-stone-500 font-medium uppercase tracking-wide">
                {formatLabel(entry.key)}
              </dt>
              <dd className="text-sm text-stone-900">
                {formatValue(entry.value) || "—"}
              </dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
};
